import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import IconButton from '@sdk/components/ui/buttons/IconButton';

export const TopBar = styled(Row)`
  background-color: ${({ theme }) => theme.colors.columnHeaders};
  padding: 20px;
  align-items: center;
  justify-content: space-between;
`;

export const AddDocumentsButton = styled(IconButton)`
  flex-grow: initial;
  margin-left: 10px;
`;
